import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';

export const componentKey = "RECIPIENT/MOVE_RECIPIENTS"

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {

        setLoadingState: (state, action) => {
            state.loadingState = action.payload
        },

        setSearchOption: (state, action) => {
            state.searchOption = action.payload;
        },

        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },

        setSelectedRecipients: (state, action) => {
            state.selectedRecipients = action.payload
        },

        setRecipientsList: (state, action) => {
            state.recipientsList = action.payload
        },

        setDeleteRecipientsModal: (state, action) => {
            state.deleteRecipientsModal = action.payload
        },

        setHighlightedRecipient: (state, action) => {
            state.highlightedRecipient = action.payload
        },

        setMoveRecipientsConfirmationModalOpen: (state, action) => {
            state.moveRecipientsConfirmationModalOpen = action.payload
        },

        setSelectPayerModalOpen: (state, action) => {
            state.selectPayerModalOpen = action.payload
        },

        setShouldReloadRecipientList: (state, action) => {
            state.shouldReloadRecipientList = action.payload
        },
        setPayerDropdownPagination: (state, action) => {
            state.payerDropdownPagination = { ...state.payerDropdownPagination, ...action.payload }
        },


    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        searchOption: { label: "Search by name", value: "NAME" },

        recipientsList: [],
        selectedRecipients: [],
        highlightedRecipient: {},

        //Modals
        deleteRecipientsModal: false,
        moveRecipientsConfirmationModalOpen: false,
        selectPayerModalOpen: false,

        paginationState: {
            PageNumber: 1,
            PageSize: 10,
            FilterText: "",
            IsDesc: true,
            IdNumber: "",
            Skip: 0,
            totalRecipients: 10,
        },
        payerDropdownPagination: {
            PageNumber: 1,
            PageSize: 10,
        },
        shouldReloadRecipientList: false,

    }
});

export const { setLoadingState, setSearchOption, setPaginationState, setSelectedRecipients, setRecipientsList, setDeleteRecipientsModal, setHighlightedRecipient, setMoveRecipientsConfirmationModalOpen, setSelectPayerModalOpen, setShouldReloadRecipientList, setPayerDropdownPagination } = actions;
